/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable prefer-const */
// import { SagaIterator } from 'redux-saga';
import { call, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { UPLOAD_FILE } from './constant';
import { postUploadAPI } from './helpers';

function* takePostUploadFileSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    ////
    let listImageSuccess = [];
    let countSuccess = 0;
    let countFail = 0;
    ////
    for (let index = 0; index < (action.payload || []).length; index++) {
      const i = (action.payload || [])[index];
      const formData = new FormData();
      formData.append('file', i.file);
      // formData.append(
      //   'file',
      //   {
      //     uri: Platform.OS === 'ios' ? i.uri.replace('file://', '') : i.uri,
      //     type: 'image/jpeg',
      //     name: i.name,
      //   },
      // );
      const { data } = yield call(postUploadAPI, formData);
      if (size(data) >= 0) {
        // action.callback?.onSuccess?.(data)
        listImageSuccess.push({
          ...i,
          linkImage: data
        })
        countSuccess++;
        if(countSuccess + countFail === size(action.payload)) {
          action.callback?.onSuccess?.(listImageSuccess)
        }
      } else {
        // action.callback?.onFail?.("Không có dữ liệu");
        countFail++;
        if(countSuccess + countFail === size(action.payload)) {
          action.callback?.onFail?.("Đã có lỗi xảy ra khi upload ảnh.");
        }
      }
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function* () {
  yield takeLatest(UPLOAD_FILE, takePostUploadFileSaga);
}

